/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */

export default {
  path: '/auth',
  name: 'auth',
  children: [
    {
      path: '/',
      name: 'auth-index',
      load: () => import(/* webpackChunkName: 'loyalty' */ './default'),
    },
    {
      path: '/reset',
      name: 'auth-forgot',
      load: () => import(/* webpackChunkName: 'loyalty' */ './password-forgot'),
    },
    {
      path: '/reset/:token',
      name: 'auth-reset',
      load: () => import(/* webpackChunkName: 'loyalty' */ './password-reset'),
    },
    {
      path: '/register',
      name: 'auth-register',
      load: () => import(/* webpackChunkName: 'loyalty' */ './register'),
    },
    {
      path: '/salon',
      name: 'auth-salon',
      load: () => import(/* webpackChunkName: 'loyalty' */ './salon'),
    },
    {
      path: '/hours',
      name: 'auth-hours',
      load: () => import(/* webpackChunkName: 'loyalty' */ './hours'),
    },
    {
      path: '/avatar',
      name: 'auth-avatar',
      load: () => import(/* webpackChunkName: 'loyalty' */ './avatar'),
    },
    {
      path: '/complete',
      name: 'auth-complete',
      load: () => import(/* webpackChunkName: 'loyalty' */ './complete'),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/routes/client/site/auth/index.js